<template>
  <CCard >
    <CCardHeader>
      <slot name="header">
        <CIcon name="cil-layers"/> {{caption}}
        <div class="card-header-actions">
          <CRow>        
            <CCol md="12" style="display:flex;">
              <div role="group" class="form-group" style="margin-bottom: 0px;">               
                <CButton color="info" size="sm"  @click="importModal()">Importar</CButton>
                <CButton color="success" size="sm"  @click="downloadExcel()">Exportar</CButton>
                <CButton color="info" size="sm" @click="storeModal()">Nuevo Vehículo</CButton>
              </div>          
            </CCol>
          </CRow>          
        </div>
      </slot>
    </CCardHeader>
    <CCardBody>
      <CRow>        
        <CCol md="12">
          <!-- FILTROS -->
          <CRow>
              <CCol md="3">
                <div role="group" class="form-group" style="margin: -10px 0px 10px">
                  <label> Tipo:</label>
                  <CSelect
                    :value.sync="typesSelect" 
                    :options="typesOptions"
                    @change="changeFilters"
                  />                        
                </div>
              </CCol> 
              <CCol md="3">
                <div role="group" class="form-group" style="margin: -10px 0px 10px">
                  <label> Departamento:</label>
                  <CSelect
                    :value.sync="departamentSelect" 
                    :options="departamentsOptions"
                    @change="changeFilters"
                  />                        
                </div>
              </CCol>              
              <CCol md="3">
                <div role="group" class="form-group" style="margin: -10px 0px 10px">
                  <label> Resguardo:</label>
                  <CSelect
                    :value.sync="personSelect" 
                    :options="personsOptions"
                    @change="changeFilters"
                  />                        
                </div>
              </CCol>  
              <CCol md="3">
                <div role="group" class="form-group" style="margin: -10px 0px 10px">
                  <label> Status:</label>
                  <CSelect
                    :value.sync="statusSelect" 
                    :options="statusOptions"
                    @change="changeFilters"
                  />                        
                </div>
              </CCol>                   
          </CRow>     
          <CRow>
            <CCol md="12">
              <div role="group" class="form-group" style="margin: -10px 0px 10px">
                <label>Buscar:</label>
                <CInput
                  :lazy="false"
                  :value.sync="searchText"
                  @input="onSearchInput"
                  placeholder="Código, nombre, tipo, departamento, resguardo..."
                />
              </div>
            </CCol>
          </CRow>
        </CCol>
      </CRow>
      <br>
      <CRow>
        <CCol md="12" style="font-size: 14px;">
          <CDataTable
            :hover="hover"
            :striped="striped"
            :border="border"
            :small="small"
            :fixed="fixed"
            :items="items"
            :fields="fields"
            :dark="dark"
          >
            <template #name="{item}">
              <td class="text-left" style="font-size: 12px;">
                <b style="font-size: 14px;">{{item.name}}</b>
                <br />
                <span style="font-size: 12px;">{{item.description}}</span>
                <span>
                  <span v-if="item.brand"><br /><b>Marca: </b><span style="font-size: 12px;">{{item.brand}} {{item.model}}</span></span>
                  <span v-if="item.color"><br /><b>Color: </b><span style="font-size: 12px;">{{item.color}}</span></span>
                </span>
              </td>
            </template>
            <template #adquisition_value="{item}"><td class="text-right">${{item.adquisition_value | currency}}</td></template>
            <template #adquisition_date="{item}"><td class="text-center">{{item.adquisition_date | date}}</td></template>
            <template #code="{item}"><td class="text-center w150">{{item.code}}</td></template>
            <template #type="{item}"><td class="text-center w200">{{item.type}}</td></template>
            <template #departament="{item}"><td class="text-center w300">{{item.departament}}</td></template>
            <template #person="{item}">
              <td class="text-center w300">
                <span v-if="item.is_active && item.person">{{item.person}}<br/><CButton color="info" size="sm" @click="downloadRecord(item)" style="height: 28px; margin-right: 10px;">Ver Resguardo</CButton></span>
                <span v-if="!item.person"><CButton v-if="item.is_active" color="warning" size="sm" @click="assignModal(item)">Asignar</CButton></span>
                <span v-if="item.is_active && item.person">
                  <br /><br />
                  <CButton v-if="item.is_active && 0" color="info" size="sm" @click="assignModal(item)" style="height: 28px; margin-right: 10px;">Traslado</CButton>
                  <CButton color="warning" size="sm" @click="reAssignModal(item)" style="height: 28px;">Reasignar</CButton>
                </span>
              </td>
            </template>
            <template #actions="{item}">
              <td style="padding: 0px; padding-bottom: 2px;" class="table_actions w150 text-center">
                  <CButton color="info" size="sm" @click="showProfileModal(item)">Ficha</CButton>
                  <CButton color="warning" size="sm" @click="updateModal(item)"><CIcon name="cil-pencil"/></CButton>
                  <template v-if="isActive(item)">
                    <CButton color="danger" size="sm" @click="deactiveModal(item)"><CIcon name="cil-ban"/></CButton>
                  </template>
                  <template v-if="!isActive(item) && !isTrashed(item)">
                    <CButton color="danger" size="sm" @click="deleteModal(item)"><CIcon name="cil-trash"/></CButton>
                  </template>
                  <template v-if="!isActive(item) && !isTrashed(item)">
                    <CButton color="success" size="sm" @click="activeModal(item)"><CIcon name="cil-check-circle"/></CButton>
                  </template>
              </td>
            </template>
          </CDataTable>
          <div class="d-flex justify-content-between align-items-center mt-2">
            <span style="font-size: 12px;">Total: {{ paginationData.totalItems }} registros</span>
            <CPagination
              :active-page.sync="currentPageLocal"
              :pages="paginationData.totalPages"
              size="sm"
              align="end"
              @update:activePage="onPageChange"
            />
          </div>
        </CCol>
      </CRow>
    </CCardBody>
    <VehicleModal ref="addModal" @store="storeProcess" @update="updateProcess"></VehicleModal>
    <VehicleProfileModal ref="profileModal" @updated="handleProfileUpdated"></VehicleProfileModal>
    <VehiclesImportModal ref="importModal" @import="importProcess"></VehiclesImportModal>
    <VehicleAssignModal ref="assignModal" @store="storeProcessAssign" @update="updateProcessAssign"></VehicleAssignModal>
    <AssetDocumentModal ref="documentModal" @store="storeProcessDocument" @delete="deleteProcessDocument"></AssetDocumentModal>
    <DeleteModal ref="deleteModal" @confirm="deleteProcess"></DeleteModal>
  </CCard>
</template>

<script>
import VehicleModal from './VehicleModal.vue';
import VehicleProfileModal from './VehicleProfileModal.vue';
import VehiclesImportModal from './VehiclesImportModal.vue';
import VehicleAssignModal from './VehicleAssignModal.vue';
import AssetDocumentModal from './AssetDocumentModal.vue';
import DeleteModal from '../global/ConfirmModal.vue';
import ws_typ from '../../services/asset_types';
import ws_dep from '../../services/asset_departaments';
import ws_per from '../../services/asset_persons';
import ws_assig from '../../services/asset_allocations';
import ws_doc from '../../services/asset_documents';
import ws from '../../services/vehicles';
import store from '../../store'
import moment from 'moment';

export default {
  name: 'VehiclesCatalogTable',
  components: { VehicleModal, VehicleProfileModal, VehiclesImportModal, DeleteModal,VehicleAssignModal,AssetDocumentModal },
  props: {
    items: Array,
    paginationData: {
      type: Object,
      default () {
        return {
          currentPage: 1,
          totalPages: 1,
          totalItems: 0,
          perPage: 30,
        }
      }
    },
    permissions: Array,
    fields: {
      type: Array,
      default () {
        return [
          {key: 'code', label: 'Codigo'},
          {key: 'name', label: 'Nombre'},
          // {key: 'serie', label: 'Serie'},
          {key: 'type', label: 'Tipo'},
          {key: 'departament', label: 'Departamento'},
          {key: 'person', label: 'Resguardo'},
          // {key: 'adquisition_date', label: 'Fecha'},
          // {key: 'adquisition_value', label: 'Valor'},
          {key: 'actions', label: 'Acciones', class: 'actions' },
        ]
      }
    },
    caption: {
      type: String,
      default: 'Table'
    },
    hover: Boolean,
    striped: Boolean,
    border: Boolean,
    small: Boolean,
    fixed: Boolean,
    dark: Boolean
  },
  data() {
    return {
      toasts: [],
      idToDelete: "",
      moduleDelete: "",
      tab: 'active',
      typesSelect: "",
      departamentSelect: "",
      personSelect: "",
      typesOptions: [],
      departamentsOptions: [],
      personsOptions: [],
      statusSelect: "",
      statusOptions: [
        {label: "Todos", value: ""},
        {label: "Activos", value: "1"},
        {label: "Inactivos", value: "0"},
        //{label: "Eliminados", value: "-1"},
      ],
      searchText: "",
      searchDebounceTimer: null,
      totals: {
        active: -1,
        inactive: -1,
      },
      currentPageLocal: 1,
    }
  },
  watch: {
    'paginationData.currentPage': {
      handler (value) {
        this.currentPageLocal = value || 1;
      },
      immediate: true
    }
  },
  mounted: async function() {
    this.loading();

    let response_typ = await ws_typ.get({ type: 'ASSETS' });
    if(response_typ.type == "success"){
      this.typesOptions = await this.$parseSelectOptionsOrdered(response_typ.data, "id", "name",[{"label": "Todos","value":""}]);
    }
    let response_dep = await ws_dep.get();
    if(response_dep.type == "success"){
      this.departamentsOptions = await this.$parseSelectOptionsOrdered(response_dep.data, "id", "name",[{"label": "Todos","value":""}]);
    }
    let response_per = await ws_per.get();
    if(response_per.type == "success"){
      this.personsOptions = await this.$parseSelectOptionsOrdered(response_per.data, "id", "name",[{"label": "Todos","value":""}]);
    }

    this.loaded();
  },
  beforeDestroy() {
    if(this.searchDebounceTimer){
      clearTimeout(this.searchDebounceTimer);
    }
  },
  methods: {
    onSearchInput () {
      if(this.searchDebounceTimer){
        clearTimeout(this.searchDebounceTimer);
      }

      this.searchDebounceTimer = setTimeout(() => {
        this.emitRefresh(1);
      }, 350);
    },
    isActive (item) {
      return Number(item && item.is_active) === 1;
    },
    isTrashed (item) {
      return Number(item && item.is_trash) === 1;
    },
    emitRefresh(page = this.currentPageLocal, options = {}) {
      this.$emit("refreshItems", { filters: this.getFilters(), page: page, ...options });
    },
    onPageChange(page) {
      this.emitRefresh(page);
    },
    changeTab (tab) {
      if(this.tab != tab){
        this.tab = tab;
        this.emitRefresh(1);
      }
    },
    async downloadExcel(){
      this.loading();

      let filters = this.getFilters();
      await ws.downloadExcel(filters);
      
      this.loaded();
    },
    async changeFilters () {
      this.emitRefresh(1);
    },
    getFilters(){
      let filters = {
        type_id: this.typesSelect,
        asset_departament_id: this.departamentSelect,
        asset_person_id: this.personSelect,
        search: this.searchText,
      };

      if(this.statusSelect !== ""){
        filters.is_active = this.statusSelect;
      }

      return filters;
    },
    storeModal () {
      this.$refs.addModal.storeModal();
    },
    updateModal (item) {
      this.$refs.addModal.updateModal(item);
    },
    async showProfileModal (item) {
      this.loading();

      let response = await ws.show({id: item.id});
      if(response.type == "success"){
        this.$refs.profileModal.openModal(response.data);
      }
      else{
        this.showToast(response.type, response.message);
      }

      this.loaded();
    },
    handleProfileUpdated () {
      this.emitRefresh();
    },
    importModal () {
      this.$refs.importModal.importModal();
    },
    assignModal (item) {
      this.$refs.assignModal.storeModal(item);
    },
    reAssignModal (item) {
      this.$refs.assignModal.updateModal(item);
    },
    unassignModal (item) {    
      this.idToDelete = item.id;
      this.moduleDelete = "unassign";
      let color = "warning";
      let title = "Desasignar Persona";
      let content = "Esta seguro que quiere desasignar a " +item.person+" del siguiente activo?"
      let confirm = item.code + " - " + item.name
      this.$refs.deleteModal.show(color,title,content,confirm);
    },  
    documentModal (item) {
      this.$refs.documentModal.storeModal(item);
    },
    deactiveModal (item) {    
      this.idToDelete = item.id;
      this.moduleDelete = "deactive";
      let color = "success";
      let title = "Archivar Registro";
      let content = "¿Estás seguro que deseas archivar el registro (dar de baja)?"
      let confirm = "<span style='font-size: 16px;font-weight: bold;'>"+item.code + " - " + item.name+"</span><br /><span style='font-size: 14px;'>"+item.description+"</span>";
      if(this.tab == "active" && item.is_active){
        color = "danger";
        title = "Archivar Registro";
        content = "¿Estás seguro que deseas archivar el activo (dar de baja)?"
      }
      this.$refs.deleteModal.show(color,title,content,confirm);
    },       
    deleteModal (item) {    
      this.idToDelete = item.id;
      this.moduleDelete = "delete";
      let color = "danger";
      let title = "Eliminar Registro";
      let content = "¿Estás seguro que deseas eliminar el registro?"
      let confirm = "<span style='font-size: 16px;font-weight: bold;'>"+item.code + " - " + item.name+"</span><br /><span style='font-size: 14px;'>"+item.description+"</span>";
      this.$refs.deleteModal.show(color,title,content,confirm);
    },  
    activeModal (item) {    
      this.idToDelete = item.id;
      this.moduleDelete = "active";
      let color = "success";
      let title = "Reactivar Registro";
      let content = "¿Estás seguro que deseas reactivar el registro?"
      let confirm = "<span style='font-size: 16px;font-weight: bold;'>"+item.code + " - " + item.name+"</span><br /><span style='font-size: 14px;'>"+item.description+"</span>";

      this.$refs.deleteModal.show(color,title,content,confirm);
    },        
    async storeProcess(data) {
      this.loading();
      let response = await ws.store(data);      
      if(response.type == "success"){
        this.emitRefresh(1, { prioritizeNew: true, pinItem: response.data || null });
      }

      this.showToast(response.type, response.message);
      this.loaded();
    },
    async updateProcess(data) {
      this.loading();
      let response = await ws.update(data);

      if(response.type == "success"){
        this.emitRefresh();
      }

      this.showToast(response.type, response.message);
      this.loaded();
    },
    async deleteProcess() {
      this.loading();
      let response = "";
      if(this.moduleDelete == "delete"){
        response = await ws.delete({id: this.idToDelete});            
      }else{
        if(this.moduleDelete == "deactive"){
          response = await ws.deactive({id: this.idToDelete});            
        }else{
          if(this.moduleDelete == "active"){
            response = await ws.active({id: this.idToDelete});            
          }else{
            response = await ws_assig.unassignVehicle({id: this.idToDelete});
          }
        }
      }

      if(response.type == "success"){
        this.emitRefresh();
      }      

      this.showToast(response.type, response.message);
      this.loaded();
    },
    async importProcess(data) {
      this.loading();
      let response = await ws.import(data);      
      if(response.type == "success"){
        this.emitRefresh(1);
      }

      this.showToast(response.type, response.message);
      this.loaded();
    },
    async storeProcessAssign(data) {
      this.loading();
      let date = moment(data.date).format("YYYY-MM-DD");

      data.date = date;
      let response = await ws_assig.storeVehicle(data);      
      if(response.type == "success"){
        this.emitRefresh();
      }

      this.showToast(response.type, response.message);
      this.loaded();
    },
    async updateProcessAssign(data) {
      this.loading();
      let response = await ws_assig.updateVehicle(data);

      if(response.type == "success"){
        this.emitRefresh();
      }

      this.showToast(response.type, response.message);
      this.loaded();
    },
    async storeProcessDocument(data) {
      console.log("entro aqui");
      this.loading();
      let response = await ws_doc.store(data);      
      if(response.type == "success"){
        this.emitRefresh();
      }

      this.showToast(response.type, response.message);
      this.loaded();
    },
    async deleteProcessDocument(data) {
      this.loading();
        let response = await ws_doc.delete({id:data});
        if(response.type == "success"){
          this.emitRefresh();
        }
        this.showToast(response.type, response.message);
      this.loaded();
    },
    async downloadRecord(item){
      this.loading();

      await ws.downloadRecord({id: item.id});
      
      this.loaded();
    },
    async initTags(){
      this.loading();
      await ws.initTags(24);
      
      this.loaded();
    },
    async downloadTags(){
      this.loading();
      let filters = this.getFilters();
      await ws.downloadTags(filters);
      
      this.loaded();
    },
    async downloadTagsMini(){
      this.loading();
      let filters = this.getFilters();
      await ws.downloadTagsMini(filters);
      
      this.loaded();
    },
    showToast(type, message){
      store.commit('toast', {color: type, message: message});
    },
    loading(){
      store.commit('loading');
    },
    loaded(){
      store.commit('loaded');
    }
  },
}
</script>
